var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _rect2, _rect3, _path48, _path49, _path50, _path51, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBretPlayGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 177,
    viewBox: "0 0 229 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4995 44.2132C65.6401 44.2132 58.458 37.0711 58.458 28.2609C58.458 19.4507 65.6401 12.3086 74.4995 12.3086C83.359 12.3086 90.541 19.4507 90.541 28.2609C90.541 37.0711 83.359 44.2132 74.4995 44.2132Z",
    fill: "#353F97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.571 30.5293C81.6204 29.1771 85.154 28.2083 89.4636 28.3655C93.7731 28.5227 97.2267 29.7463 97.1773 31.0985C97.1279 32.4507 93.5943 33.4195 89.2848 33.2623C84.9752 33.1051 81.5217 31.8815 81.571 30.5293Z",
    fill: "#353F97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6413 27.5215C50.6907 26.1692 54.2243 25.2005 58.5339 25.3577C62.8434 25.5149 66.297 26.7385 66.2476 28.0907C66.1982 29.4429 62.6646 30.4116 58.3551 30.2545C54.0455 30.0973 50.592 28.8737 50.6413 27.5215Z",
    fill: "#353F97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1747 34.8932C69.0904 35.3484 69.0978 35.8156 69.1965 36.268C69.2951 36.7204 69.4831 37.1492 69.7496 37.5298C70.0162 37.9105 70.3561 38.2355 70.7499 38.4864C71.1437 38.7373 71.5837 38.909 72.0448 38.9919C72.5059 39.0748 72.979 39.0672 73.4371 38.9694C73.8952 38.8717 74.3293 38.6858 74.7146 38.4223C75.0999 38.1588 75.4288 37.823 75.6826 37.4339C75.9364 37.0449 76.11 36.6102 76.1936 36.1549L76.1949 36.1481C76.5458 34.2339 75.047 33.5565 73.1084 33.21C71.1698 32.8634 69.5256 32.979 69.1747 34.8932Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9299 40.8125H81.6289V49.396H76.9299V40.8125Z",
    fill: "#353F97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2092 40.8125H71.9082V49.396H67.2092V40.8125Z",
    fill: "#353F97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.659 51.1767C75.4665 51.1767 73.6892 50.4879 73.6892 49.6382C73.6892 48.7884 75.4665 48.0996 77.659 48.0996C79.8515 48.0996 81.6289 48.7884 81.6289 49.6382C81.6289 50.4879 79.8515 51.1767 77.659 51.1767Z",
    fill: "#353F97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9383 51.0156C65.7458 51.0156 63.9685 50.3267 63.9685 49.477C63.9685 48.6273 65.7458 47.9385 67.9383 47.9385C70.1308 47.9385 71.9082 48.6273 71.9082 49.477C71.9082 50.3267 70.1308 51.0156 67.9383 51.0156Z",
    fill: "#353F97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0933 29.637C71.0954 29.637 68.6651 27.2079 68.6651 24.2115C68.6651 21.2152 71.0954 18.7861 74.0933 18.7861C77.0912 18.7861 79.5215 21.2152 79.5215 24.2115C79.5215 27.2079 77.0912 29.637 74.0933 29.637Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9315 25.9124C72.9024 25.9124 72.0681 25.0786 72.0681 24.0499C72.0681 23.0213 72.9024 22.1875 73.9315 22.1875C74.9606 22.1875 75.7949 23.0213 75.7949 24.0499C75.7949 25.0786 74.9606 25.9124 73.9315 25.9124Z",
    fill: "#3F3D56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9816 13.3073C91.2769 7.55041 87.1363 1.7333 80.7334 0.314437C74.3304 -1.10443 68.0898 2.41226 66.7945 8.16917C65.4992 13.9261 69.7427 16.0493 76.1456 17.4682C82.5485 18.887 88.6863 19.0642 89.9816 13.3073Z",
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40.2998,
    width: 189,
    height: 116.7,
    rx: 20,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 64,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#004FC4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.446 78.8319C135.602 79.6305 134.673 80.0837 133.806 80.1588C133.652 80.1713 133.498 80.1713 133.344 80.1588C133.303 80.1588 133.261 80.1513 133.219 80.145C133.02 80.1201 132.826 80.0713 132.639 79.9998C132.196 79.8344 131.821 79.526 131.573 79.1236C131.55 79.0885 131.53 79.051 131.511 79.0147C131.394 78.7889 131.324 78.542 131.305 78.2886C131.27 77.7282 131.455 77.1763 131.82 76.7501C131.845 76.7176 131.873 76.685 131.902 76.6537C132.175 76.3486 132.496 76.0906 132.853 75.8901C133.075 75.7649 133.279 75.6398 133.468 75.5021L133.569 75.4307C133.996 75.1344 134.38 74.781 134.711 74.3804C134.737 74.3491 134.762 74.3166 134.785 74.284C135.092 73.9039 135.292 73.4483 135.364 72.9646C135.364 72.9246 135.373 72.8858 135.374 72.847C135.398 72.5323 135.329 72.2175 135.175 71.9419C135.081 71.7753 134.959 71.6263 134.814 71.5013C134.781 71.4716 134.746 71.444 134.71 71.4186C134.318 71.1492 133.853 71.0087 133.378 71.0168V71.0168C133.336 71.0168 133.295 71.0168 133.252 71.0168C132.768 71.0303 132.288 71.1182 131.83 71.2772L131.705 71.3197C131.39 71.4336 131.085 71.5739 130.794 71.7391C130.622 71.8367 130.455 71.9377 130.293 72.042L130.179 72.1184C129.762 72.3982 129.367 72.7091 128.996 73.0485L128.904 73.1336C127.716 74.2486 126.775 75.6005 126.142 77.1019L125.958 77.0343L125.207 76.7576C125.98 74.8736 127.207 73.2095 128.777 71.9131L128.924 71.7954C129.359 71.4518 129.819 71.1417 130.301 70.8678L130.362 70.834C130.427 70.7977 130.487 70.7627 130.555 70.7301C131.062 70.4604 131.602 70.2572 132.161 70.1255V70.1255L132.345 70.088C132.888 69.9779 133.447 69.9711 133.992 70.0679C134.047 70.0767 134.101 70.0892 134.155 70.1017C134.776 70.2365 135.337 70.5654 135.759 71.0406C135.792 71.0794 135.824 71.1194 135.855 71.1658C135.925 71.2558 135.988 71.3508 136.044 71.4499C136.366 72.0225 136.466 72.6938 136.323 73.3352V73.3352C136.314 73.3815 136.304 73.4265 136.293 73.4716C136.101 74.1528 135.742 74.7754 135.249 75.283C135.215 75.3205 135.18 75.3568 135.144 75.3944C134.682 75.8612 134.164 76.2683 133.6 76.6062L133.449 76.6975L133.356 76.7526C133.012 76.9354 132.718 77.1982 132.496 77.5187C132.466 77.5666 132.438 77.6164 132.414 77.6677C132.33 77.8343 132.293 78.0201 132.305 78.206C132.32 78.3963 132.395 78.5771 132.518 78.723C132.556 78.768 132.598 78.8099 132.643 78.8482V78.8482C132.75 78.9415 132.874 79.0149 133.007 79.0647C133.188 79.1328 133.38 79.1675 133.573 79.1674C133.623 79.1674 133.674 79.1674 133.727 79.1674C134.364 79.1186 135.084 78.7505 135.764 78.1083L136.181 78.549L136.446 78.8319Z",
    fill: "#E8D1A0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.993 73.048L128.9 73.1331C128.748 72.7452 128.705 72.3233 128.775 71.9126L128.921 71.7949C128.819 72.2103 128.844 72.6468 128.993 73.048V73.048Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.292 72.0414L130.178 72.1178C130.112 71.6812 130.174 71.2348 130.358 70.8334C130.423 70.7971 130.483 70.762 130.551 70.7295C130.328 71.1282 130.237 71.5877 130.292 72.0414V72.0414Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.34 70.0879C132.051 70.4218 131.873 70.8374 131.83 71.2771L131.705 71.3197C131.739 70.8889 131.893 70.4763 132.151 70.1292V70.1292L132.34 70.0879Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.149 70.1019C133.807 70.3252 133.538 70.6431 133.373 71.017C133.332 71.017 133.291 71.017 133.248 71.017C133.406 70.6404 133.662 70.3131 133.989 70.0693C134.048 70.0768 134.096 70.0894 134.149 70.1019Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.852 71.1606C135.482 71.1817 135.123 71.2991 134.811 71.5011C134.778 71.4715 134.743 71.4439 134.707 71.4185C135.02 71.2075 135.38 71.0784 135.756 71.043C135.79 71.0793 135.821 71.1193 135.852 71.1606Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.319 73.3296C136.31 73.3759 136.3 73.421 136.289 73.4661C136.027 73.2253 135.71 73.0532 135.365 72.9653C135.365 72.9253 135.374 72.8865 135.375 72.8477C135.724 72.931 136.047 73.0962 136.319 73.3296V73.3296Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.25 75.2833C135.216 75.3208 135.181 75.3571 135.145 75.3947C135.093 75.0229 134.944 74.6713 134.713 74.3757C134.739 74.3444 134.764 74.3118 134.787 74.2793C135.022 74.5703 135.181 74.9153 135.25 75.2833V75.2833Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.601 76.6111L133.449 76.7025C133.569 76.3123 133.576 75.896 133.469 75.502L133.571 75.4307C133.685 75.8146 133.695 76.2219 133.601 76.6111V76.6111Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.496 77.5243C132.465 77.5722 132.438 77.6219 132.413 77.6733C132.3 77.3195 132.096 77.0014 131.822 76.7507C131.847 76.7181 131.875 76.6856 131.904 76.6543C132.167 76.8938 132.369 77.1919 132.496 77.5243Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.637 78.849C132.265 78.8468 131.899 78.9413 131.575 79.1231C131.552 79.0881 131.532 79.0505 131.514 79.0142C131.82 78.8412 132.163 78.743 132.515 78.7275C132.552 78.7712 132.593 78.8118 132.637 78.849V78.849Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M133.721 79.1641C133.514 79.461 133.385 79.8054 133.346 80.1655C133.305 80.1655 133.263 80.158 133.221 80.1517C133.26 79.8037 133.379 79.4692 133.567 79.1741C133.618 79.1703 133.674 79.1641 133.721 79.1641Z",
    fill: "#E8D1A0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M136.446 78.8322C135.602 79.6308 134.673 80.084 133.806 80.1591C133.411 80.1952 133.012 80.1413 132.641 80.0014C132.278 79.8726 131.96 79.6428 131.723 79.3392C131.487 79.0356 131.342 78.6707 131.306 78.2876C131.235 77.3725 131.799 76.4988 132.855 75.8891C135.233 74.5121 135.734 72.9173 135.172 71.9409C134.421 70.624 132.351 70.8531 130.79 71.7381C127.452 73.6284 126.159 77.0658 126.141 77.1009L125.957 77.0333C126.632 75.1556 128.586 71.3438 132.733 70.649C132.733 70.649 134.796 70.3724 135.48 71.7356C136.223 73.2203 135.695 74.566 133.248 76.0769C130.882 77.5365 131.784 78.7533 132.19 79.2953C132.612 79.8624 134.161 80.3481 136.177 78.5442L136.446 78.8322Z",
    fill: "#E8D1A0"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.61 76.5811C140.858 77.2796 139.324 78.4075 142.432 81C138.885 79.2475 138.658 81.1803 138.539 83.9656C137.612 80.6345 136.206 79.7683 132.818 81.6022C134.935 78.6929 135.823 77.8142 132.658 74.7335C132.658 74.7335 137.142 77.6414 137.135 72.3838C137.652 76.7864 140.085 74.2941 140.715 73.3039C140.064 74.5757 138.858 76.695 142.61 76.5811Z",
    fill: "#FF822F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M137.512 74.7822C137.538 75.8726 138.331 76.5535 139.64 75.7837C138.004 77.3785 140.734 77.2358 140.734 77.2358C139.388 77.5838 138.083 78.0432 138.198 81.3054C138.198 81.3054 137.958 78.0432 134.744 80.0649C134.744 80.0649 137.631 78.4626 135.525 76.7551C137.531 77.053 137.512 74.7822 137.512 74.7822Z",
    fill: "#FFBB0F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.063 73.2045C127.46 72.7175 126.865 72.4534 126.734 72.6186L124.973 74.8018L127.156 76.5631L128.916 74.3799C129.049 74.2172 128.666 73.6902 128.063 73.2045Z",
    fill: "url(#paint0_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.535 87.6553C126.696 87.6553 130.069 84.2819 130.069 80.1206C130.069 75.9593 126.696 72.5859 122.535 72.5859C118.373 72.5859 115 75.9593 115 80.1206C115 84.2819 118.373 87.6553 122.535 87.6553Z",
    fill: "url(#paint1_radial)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M128.246 84.6712C127.562 85.5203 126.699 86.2085 125.72 86.6871C124.74 87.1658 123.667 87.4231 122.577 87.4409C121.486 87.4587 120.406 87.2365 119.411 86.7901C118.416 86.3437 117.532 85.684 116.82 84.8577C116.887 84.9166 116.954 84.9729 117.022 85.028C118.073 85.8774 119.336 86.4236 120.675 86.6078C121.275 86.6912 121.883 86.7 122.485 86.634C123.836 86.4912 125.122 85.981 126.203 85.1588C127.284 84.3366 128.119 83.2338 128.618 81.9702C129.117 80.7066 129.259 79.3306 129.031 77.9916C128.802 76.6525 128.211 75.4017 127.322 74.375C128.781 75.6362 129.693 77.4152 129.866 79.3363C130.038 81.2574 129.457 83.1703 128.246 84.6712V84.6712Z",
    fill: "url(#paint2_radial)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.653 76.3779C137.878 77.0326 137.973 77.0714 138.487 76.771C137.823 77.477 139.05 77.6022 139.05 77.6022C138.298 77.8225 137.913 77.9865 138.027 78.7451C138.027 78.7451 137.743 78.0428 136.83 78.7201C136.83 78.7201 137.4 77.8325 136.946 77.3581C137.889 77.5609 137.653 76.3779 137.653 76.3779Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.742 73.4178C137.742 73.4629 137.305 70.9492 137.305 70.9492C137.305 70.9492 137.693 71.8731 137.742 73.4178Z",
    fill: "#FF822F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.829 72.2686L136.713 73.8634C136.662 73.329 136.701 72.7899 136.829 72.2686V72.2686Z",
    fill: "#FF822F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.474 74.7823C140.394 74.8787 141.775 72.668 141.775 72.668C141.435 73.4264 140.998 74.1372 140.474 74.7823V74.7823Z",
    fill: "#FF822F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.472 75.2171C140.433 75.2321 141.55 74.332 141.55 74.332C141.55 74.332 140.934 75.033 140.472 75.2171Z",
    fill: "#FF822F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M141.654 77.4346L143.874 77.2093C143.127 77.1612 142.377 77.2374 141.654 77.4346V77.4346Z",
    fill: "#FF822F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M143.023 76.551L145 76.2393C145 76.2393 144.203 76.014 143.023 76.551Z",
    fill: "#FF822F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132.286 74.3783C132.358 74.5035 130.533 73.0664 130.533 73.0664C130.533 73.0664 131.843 73.5784 132.286 74.3783Z",
    fill: "#FF822F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.591 74.7822C133.591 74.7822 132.207 73.28 132.188 73.3314C132.169 73.3827 133.149 73.7194 133.591 74.7822Z",
    fill: "#FF822F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.245 80.5059C133.187 80.5447 131.629 82.1595 131.629 82.1595C131.629 82.1595 131.994 81.2757 133.187 80.5447",
    fill: "#FF822F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138.289 84.9406L137.863 82.9902C137.863 82.9902 138.367 84.038 138.289 84.9406Z",
    fill: "#FF822F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.085 80.1051C136.161 80.0174 134.012 81.6072 134.012 81.6072C134.012 81.6072 135.486 80.8023 136.085 80.1051Z",
    fill: "#FFBB0F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.844 79.9805L139.26 82.409C138.946 81.6394 138.805 80.8106 138.844 79.9805V79.9805Z",
    fill: "#FFBB0F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M135.505 77.3149C135.585 77.3412 133.252 76.0781 133.252 76.0781C133.252 76.0781 134.457 76.9657 135.505 77.3149Z",
    fill: "#FFBB0F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138.118 74.3192C138.11 74.3718 137.777 72.3389 137.777 72.3389C137.777 72.3389 138.22 73.6871 138.118 74.3192Z",
    fill: "#FFBB0F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M134.248 77.4346L135.593 77.6474C135.134 77.6703 134.677 77.5979 134.248 77.4346V77.4346Z",
    fill: "#FFBB0F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.645 78.8262C139.645 78.8262 140.632 79.7438 142.363 79.9816L139.645 78.8262Z",
    fill: "#FFBB0F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M139.932 78.623C140.449 78.8717 140.996 79.0534 141.559 79.1638C141.559 79.1638 140.348 78.6631 139.932 78.623Z",
    fill: "#FFBB0F"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M126.102 75.5725C126.078 77.0747 125.77 78.6169 121.275 79.2929C116.941 79.9451 116.173 83.3901 115.836 80.8552C115.328 77.0409 117.824 74.322 120.484 73.5533C123.884 72.5707 126.127 74.0578 126.102 75.5725Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M116.08 83.0816C116.08 83.0816 118.938 88.1214 124.661 85.9233C129.885 83.9203 129.008 78.3448 129.008 78.3448C129.046 78.3322 127.984 83.2757 122.295 84.3472C117.988 85.1546 116.08 83.0816 116.08 83.0816Z",
    fill: "url(#paint4_radial)"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 104,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#004FC4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 104,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#004FC4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.048 32.3719C134.044 35.001 134.648 37.5955 135.813 39.9526C135.945 40.2233 136.084 40.4861 136.231 40.7489H166.175C166.323 40.4861 166.462 40.2233 166.594 39.9526C167.737 37.6358 168.342 35.0908 168.363 32.5077C168.384 29.9245 167.821 27.37 166.716 25.0348C165.611 22.6996 163.992 20.6442 161.981 19.0219C159.969 17.3997 157.617 16.2526 155.1 15.6663C152.583 15.08 149.966 15.0696 147.444 15.636C144.922 16.2024 142.561 17.3308 140.537 18.9371C138.513 20.5434 136.878 22.586 135.755 24.9123C134.631 27.2387 134.048 29.7887 134.048 32.3719Z",
    fill: "#353F97"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M150.769 33.8897C147.531 33.8897 144.906 31.266 144.906 28.0293C144.906 24.7927 147.531 22.1689 150.769 22.1689C154.008 22.1689 156.633 24.7927 156.633 28.0293C156.633 31.266 154.008 33.8897 150.769 33.8897Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M150.768 29.9831C149.689 29.9831 148.814 29.1085 148.814 28.0296C148.814 26.9508 149.689 26.0762 150.768 26.0762C151.848 26.0762 152.723 26.9508 152.723 28.0296C152.723 29.1085 151.848 29.9831 150.768 29.9831Z",
    fill: "#3F3D56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M167.846 16.4238C169.231 10.2232 164.803 3.95773 157.956 2.4295C151.108 0.90126 144.434 4.68901 143.049 10.8897C141.663 17.0903 146.202 19.3772 153.049 20.9054C159.897 22.4336 166.461 22.6245 167.846 16.4238Z",
    fill: "#00B7C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 20.2998,
    width: 229,
    height: 156.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 125.952,
    y1: 73.7352,
    x2: 128.325,
    y2: 75.3664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#827F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2B2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.535 80.1206) rotate(90) scale(7.53469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.031 82.2339) scale(6.53577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.525 75.3134) scale(10.8834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE9E9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8882.37 1186.47) scale(1200.8 752.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE9E9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D4D",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBretPlayGame);
export default __webpack_public_path__ + "static/media/BRET-playGame.93c493ba069e97c2e4836714910e3e2c.svg";
export { ForwardRef as ReactComponent };